import { useCallback, useRef, useState } from 'react';

const usePasswordVisibility = () => {
  const [isVisible, setIsVisible] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const toggleVisibility = useCallback(() => {
    const nextVisible = !isVisible;
    const input = inputRef.current;

    // Safari only reveals a suggested password if type changes during this click,
    // not after React re-renders.
    if (input) {
      input.type = nextVisible ? 'text' : 'password';
    }

    setIsVisible(nextVisible);
  }, [isVisible]);

  return { isVisible, inputRef, toggleVisibility };
};

export default usePasswordVisibility;
